import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Briefcase } from 'lucide-react';

const Experience = ({ data }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section id="experience" className="py-24 bg-[#0F0F0F]">
      <div className="container mx-auto px-6">
        <div 
          ref={ref}
          className={`max-w-5xl mx-auto transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-16 text-center">
            Work <span className="text-[#0066FF]">Experience</span>
          </h2>

          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-0 md:left-1/2 transform md:-translate-x-1/2 h-full w-0.5 bg-white/10"></div>

            {data.map((exp, index) => (
              <div 
                key={exp.id}
                className={`relative mb-12 ${
                  index % 2 === 0 ? 'md:pr-1/2' : 'md:pl-1/2 md:ml-auto'
                }`}
                style={{
                  animation: inView ? `fadeInUp 0.6s ease-out ${index * 150}ms both` : 'none'
                }}
              >
                <div className={`flex items-center mb-4 ${
                  index % 2 === 0 ? 'md:justify-end' : 'md:justify-start'
                }`}>
                  {/* Timeline dot */}
                  <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[#0066FF] rounded-full border-4 border-[#0F0F0F] z-10"></div>
                  
                  <div className={`pl-8 md:pl-0 ${
                    index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'
                  } w-full md:w-1/2`}>
                    <div className="bg-[#1A1A1A] p-6 rounded-2xl border border-white/10 hover:border-[#0066FF]/50 transition-all duration-500 hover:transform hover:scale-105 hover:shadow-xl hover:shadow-[#0066FF]/10">
                      <div className="flex items-center gap-3 mb-3">
                        <Briefcase className="text-[#0066FF]" size={20} />
                        <span className="text-sm text-[#0066FF] font-medium">
                          {exp.year}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold text-white mb-2">
                        {exp.title}
                      </h3>
                      <p className="text-[#0066FF] font-medium mb-3">
                        {exp.company}
                      </p>
                      <p className="text-gray-400 text-sm">
                        {exp.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Experience;
